/** How the Customers page formats visit times: in the Venue's timezone and the UI locale. */
export interface VisitFormat {
  locale: string;
  timezone: string;
}

/** A visit window boundary as a 24-hour Venue-local time, e.g. `17:30`. */
export function windowTime(instant: string, format: VisitFormat): string {
  return new Intl.DateTimeFormat(format.locale, {
    timeZone: format.timezone,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(new Date(instant));
}

/** An instant as a Venue-local date and time. */
export function moment(instant: string, format: VisitFormat): string {
  return new Intl.DateTimeFormat(format.locale, {
    timeZone: format.timezone,
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(instant));
}
